import { useMemo } from 'react'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'

export function useGroupedCoursesBySerie(
  desiredCourses: DesiredEducationCourse[]
) {
  const groupedCoursesBySerie = useMemo(() => {
    if (!desiredCourses) return {}

    return desiredCourses.reduce<
      Record<
        string,
        { courses: DesiredEducationCourse[]; totalWorkload: number }
      >
    >((acc, course) => {
      acc[course.serie] ??= {
        courses: [],
        totalWorkload: 0
      }
      acc[course.serie].courses.push(course)
      acc[course.serie].totalWorkload += course.workload
      return acc
    }, {})
  }, [desiredCourses])

  return {
    groupedCoursesBySerie
  }
}
